import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;

export const Left = styled.div`
  flex-shrink: 0;
`;

export const Right = styled.div`
  margin-left: 8px;
  line-height: 1.2;
  flex-grow: 1;
  overflow: hidden;
`;

export const Name = styled.h6`
  flex-basis: 0;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Sub = styled.div`
  font-size: 14px;
  color: #69738a;
`;

export const AttemptsInline = styled.div`
  display: flex;
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-right-width: 1px;
  border-color: #ccc;
  border-style: solid;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
`;
export const AttemptsInlineAttempt = styled.div<{
  success: boolean;
  zone: boolean;
  isSummary?: boolean;
}>`
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  font-size: 14px;
  & + & {
    border-left: 1px solid #ccc;
  }
  background-color: white;
  font-weight: bold;
  color: ${({ success, zone }) => (zone && !success ? "white" : "black")};
  ${({ success, zone }) =>
    success
      ? "background: #45D27E;"
      : zone
      ? "background: radial-gradient(100% 2434.05% at 2.19% 0%, #2C8DFF 0%, #0075FF 100%);"
      : ""}
  ${({ isSummary }) => (isSummary ? "width: 24px; color: #888" : "")}
`;
